import { Component, EventEmitter, Output, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

type Data = { title: string, confirmButtonText: string, cancelButtonText: string, body: string, subject: string, toList: string };

@Component({
    selector: "app-email-preview-modal",
    templateUrl: "./email-preview-modal.component.html",
    styleUrls: ["./email-preview-modal.component.scss"],
    standalone: false
})
export class EmailPreviewModalComponent {
  @Output() confirm = new EventEmitter<boolean>();

  title = '';
  confirmButtonText = 'Save';
  cancelButtonText = 'Cancel';

  constructor(
    public dialogRef: MatDialogRef<EmailPreviewModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Data
  ) {
    this.title = data.title || this.title;
    this.confirmButtonText = data.confirmButtonText || this.confirmButtonText;
    this.cancelButtonText = data.cancelButtonText || this.cancelButtonText;
  }

  onCancelClick(): void {
    this.confirm.emit(false);
  }

  onConfirmClick(): void {
    this.confirm.emit(true);
  }
}